import gql from 'graphql-tag';

export default gql`
  mutation ExtractIngredients($input: DailyTrackerExtractIngredientsInputType!) {
    dailyTracker {
      extractIngredients(input: $input) {
        ... on ExtractedIngredients {
          mealName
          portions
          ingredients {
            productId
            name
            brand
            baseAmount
            baseUnit
            calories
            proteinGrams
            fatGrams
            carbsGrams
            measurement {
              measureId
              amount
              unit
              text
            }
          }
          imageUrl
        }
        ... on NotFoodError {
          message
          description
        }
        ... on AiAccessDenied {
          accessDeniedMessage: message
          accessDeniedDescription: description
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
